import {
  DOUBLE_BLOCK_SECTION_WIDTH,
  FeatureBlockProps,
  SINGLE_BLOCK_SECTION_WIDTH,
} from '../FeatureBlock/FeatureBlock.d'
import css from './FeatureSection.module.scss'
import FeatureBlock from '../FeatureBlock'

export interface FeatureSectionProps {
  featureBlocks: FeatureBlockProps[]
  slot?: number
}

export const FeatureSection = ({
  featureBlocks,
  slot,
}: FeatureSectionProps) => {
  if (featureBlocks.length < 1 || featureBlocks.length > 2) {
    return null
  }

  const imageWidth =
    featureBlocks.length === 1
      ? SINGLE_BLOCK_SECTION_WIDTH
      : DOUBLE_BLOCK_SECTION_WIDTH

  return (
    <div className={css.FeatureSection}>
      {featureBlocks.map((block: FeatureBlockProps) => (
        <FeatureBlock {...block} imageWidth={imageWidth} slot={slot} />
      ))}
    </div>
  )
}

export default FeatureSection
